import { LegalLayout, LegalSection as S } from "../components/LegalLayout";
import { COMPANY as C } from "../constants/company";

const Mail = () => <a href={`mailto:${C.email}`} className="underline decoration-coral decoration-2 underline-offset-4">{C.email}</a>;

export default function Terms() {
  return (
    <LegalLayout title="Terms & Conditions" updated={C.updated} testid="terms-page">
      <S title="About us">
        <p>Reuben's Reads is a trading name of {C.name}, a company registered in England and Wales (company number {C.number}).
          Postal address: {C.address}. Email: <Mail />.</p>
      </S>
      <S title="Prices and payment">
        <p>The Party Pet Shop costs £6.00 per copy. UK postage is £1.50 per order. The total you pay is shown before you pay.</p>
        <p>Payments are taken securely by Stripe. Your order is confirmed once your payment has gone through and you've received a confirmation email.</p>
      </S>
      <S title="Delivery">
        <p>We currently post to UK addresses only. We aim to post your order within 5 working days of you ordering.</p>
        <p>If your book hasn't arrived after a reasonable time, please email us and we'll help.</p>
      </S>
      <S title="Changing your mind">
        <p>You can cancel your order within 14 days of receiving your book, without giving a reason. To do this, email us, then return the book unused to our postal address within 14 days of telling us.</p>
        <p>Once we receive the book, we'll refund the price of the book within 14 days. The cost of posting the book back to us is yours to pay.</p>
      </S>
      <S title="Damaged or faulty books">
        <p>If your book arrives damaged, email us within 14 days (a photo helps). We'll send a replacement or give you a full refund, whichever you prefer. You also have your legal rights under the Consumer Rights Act 2015.</p>
      </S>
      <S title="Complaints">
        <p>If something isn't right, email <Mail /> and we'll do our best to sort it out quickly.</p>
      </S>
      <S title="The legal bit">
        <p>Nothing in these terms affects your legal rights as a consumer. These terms are governed by the law of England and Wales.</p>
      </S>
    </LegalLayout>
  );
}
